import { render } from "./CourseFormModal.vue?vue&type=template&id=23e1b9da&scoped=true"
import script from "./CourseFormModal.vue?vue&type=script&lang=js"
export * from "./CourseFormModal.vue?vue&type=script&lang=js"

import "./CourseFormModal.vue?vue&type=style&index=0&id=23e1b9da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e1b9da"]])

export default __exports__